<!-- 首页 -->
<template>
  <div class="container">
    <div class="noticeWarp">
      <h3 class="noticeTitle" v-text="noticeDetails.title"></h3>
      <p class="noticeAddTime">时间：{{noticeDetails.addTime}}</p>
      <div class="noticeContent" v-html="noticeDetails.content"></div>
      <img :src="noticeDetails.picUrl" alt="" class="noticePic">
    </div>
  </div>
</template>

<script>
import orderSearch from "@/components/orderSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
  inject: ['$http', '$api', '$utils','$userUtils', '$uploadFileUtils'],
  name: "memberShipList",
  components: {
    orderSearch,
    basetable,
    basedialog,
	  tableDataSelect,
  },
  data() {
    return{
      id: "",
      noticeDetails: {}
    }
  },
  mounted() {
    this.id = this.$route.query.id;

    //获取公告详情
    if(this.id) {
      this.queryArticleInfo();
    }
  },
  methods: {
    /**
     * 获取公告详情
     */
    queryArticleInfo() {
      let that = this;
      that.$http.post(that.$api.queryArticleInfoApi, {
        "id": that.id
      }).then(res => {
        if(res.code == 200) {
          that.noticeDetails = res.data;
          that.noticeDetails.addTime = !that.$utils.isEmpty(that.noticeDetails.addTime) ? that.$utils.getDateTime(that.noticeDetails.addTime) : "--";
        }
      })
    }
  }
}
</script>

<style scoped>
.noticeWarp{
  background-color: #fff;
  padding: 16px;
}
.noticeTitle{
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  color: #000;
}
.noticeAddTime{
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}
.noticePic{
  max-width: 60%;
  display: block;
  margin: 16px auto;
}
.noticeContent{
  width: 60%;
  margin-left: 20%;
}
</style>
<style>
.noticeContent p, .noticeContent span{
  font-size: 16px !important;
  line-height: 22px !important;
}
.noticeContent img{
  max-width: 100%;
}
</style>


